import { arrayOf, bool, shape, string } from 'prop-types'

import Breadcrumb_v2 from './Breadcrumb_v2'
import Subcategory_v2 from './Subcategory_v2'

export default {
  breadcrumb: arrayOf(shape(Breadcrumb_v2)),
  canonicalUrl: string,
  hasSubcategories: bool,
  id: string,
  isCategory: bool,
  isDirectChild: bool,
  name: string,
  redirectUrl: string,
  seoName: string,
  subcategories: arrayOf(shape(Subcategory_v2)),
  urlMappingForOtherShops: shape({}),
}
